import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-navy-dark text-white overflow-x-hidden">
    <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
      {/* logo e descrição */}
      <div className="flex flex-col items-center md:items-start space-y-4">
        <Link to="/#hero" className="inline-block">
          <img
            src="/imagem/logo-horizontal.png"
            alt="AEAGO"
            className="h-16 lg:h-20 xl:h-24 w-auto"
          />
        </Link>

        <p className="text-sm text-center md:text-left">
          Associação dos Engenheiros Agrônomos de Goiás Desde 1965, fortalecendo a
          engenharia agronômica e promovendo o desenvolvimento sustentável do
          agronegócio goiano.
        </p>
      </div>

      {/* links rápidos */}
      <div className="flex flex-col items-center">
        <h4 className="font-semibold text-lg mb-3 text-white">Links Rápidos</h4>
        <ul className="space-y-2 text-sm">
          <li>
            <Link to="/#about" className="text-white hover:underline">
              Sobre
            </Link>
          </li>
          <li>
            <Link to="/#cursos" className="text-white hover:underline">
              Cursos
            </Link>
          </li>
          <li>
            <Link to="/#noticias" className="text-white hover:underline">
              Notícias
            </Link>
          </li>
          <li>
            <Link to="/#eventos" className="text-white hover:underline">
              Eventos
            </Link>
          </li>
          <li>
            <Link to="/#contato" className="text-white hover:underline">
              Contato
            </Link>
          </li>
        </ul>
      </div>

      {/* redes sociais */}
      <div className="flex flex-col items-center">
        <h4 className="font-semibold text-lg mb-3 text-white">Redes Sociais</h4>
        <div className="flex space-x-3">
          <a
            href="https://www.facebook.com/share/1GPi6jYbjc/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-navy-light p-2 rounded-lg hover:bg-navy"
            aria-label="Facebook"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M22 12a10 10 0 10-11.61 9.88v-6.99h-2.1v-2.89h2.1V9.41c0-2.07 1.23-3.22 3.11-3.22.9 0 1.84.16 1.84.16v2.02h-1.03c-1.01 0-1.32.63-1.32 1.27v1.53h2.24l-.36 2.89h-1.88v6.99A10 10 0 0022 12z" />
            </svg>
          </a>

          <a
            href="https://www.instagram.com/aeagoficial"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-navy-light p-2 rounded-lg hover:bg-navy"
            aria-label="Instagram"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zM12 7a5 5 0 110 10 5 5 0 010-10zm6.5-.75a1.25 1.25 0 11-.001 2.501A1.25 1.25 0 0118.5 6.25z" />
            </svg>
          </a>

          <a
            href="https://www.linkedin.com/in/aeago-associa%C3%A7%C3%A3o-dos-engenheiros-agr%C3%B4nomos-de-goi%C3%A1s-a6403912b/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-navy-light p-2 rounded-lg hover:bg-navy"
            aria-label="LinkedIn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M4.98 3.5a2.5 2.5 0 11-.001 5.001A2.5 2.5 0 014.98 3.5zM2 9h6v12H2V9zm7 0h5.5v1.71h.08c.77-1.46 2.66-3 5.47-3 5.86 0 6.93 3.85 6.93 8.85V21h-6v-6.5c0-1.55-.03-3.55-2.16-3.55-2.16 0-2.49 1.69-2.49 3.44V21h-6V9z" />
            </svg>
          </a>

          <a
            href="https://www.youtube.com/@aeagoassociacaodosengenhei5986"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-navy-light p-2 rounded-lg hover:bg-navy"
            aria-label="YouTube"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M23.498 6.186a2.994 2.994 0 00-2.112-2.117C19.667 3.5 12 3.5 12 3.5s-7.667 0-9.386.569a2.994 2.994 0 00-2.112 2.117C0 7.91 0 12 0 12s0 4.09.502 5.814a2.994 2.994 0 002.112 2.117C4.333 20.5 12 20.5 12 20.5s7.667 0 9.386-.569a2.994 2.994 0 002.112-2.117C24 16.09 24 12 24 12s0-4.09-.502-5.814zM9.545 15.568v-7.136l6.545 3.568-6.545 3.568z" />
            </svg>
          </a>
        </div>
      </div>
    </div>

    <div className="border-t border-navy-light py-4 text-center text-xs">
      © {new Date().getFullYear()} AEAGO - Associação dos Engenheiros Agrônomos de Goiás.
      Todos os direitos reservados.
    </div>
  </footer>
);

export default Footer;